module.exports = __webpack_public_path__ + "img/news9-1.785105bc.png";